var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    rx: 25.5,
    fill: "#4A93CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 26.4688L15.8438 26.4687C15.5868 26.4687 15.3404 26.3667 15.1587 26.185C14.9771 26.0033 14.875 25.7569 14.875 25.5C14.875 25.2431 14.9771 24.9967 15.1587 24.815C15.3404 24.6333 15.5868 24.5312 15.8438 24.5312L35.2188 24.5312C35.4757 24.5312 35.7221 24.6333 35.9038 24.815C36.0854 24.9967 36.1875 25.2431 36.1875 25.5C36.1875 25.7569 36.0854 26.0033 35.9038 26.185C35.7221 26.3667 35.4757 26.4688 35.2188 26.4688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8177 25.5L26.7829 17.4671C26.6009 17.2852 26.4988 17.0385 26.4988 16.7812C26.4988 16.524 26.6009 16.2773 26.7829 16.0954C26.9648 15.9135 27.2115 15.8113 27.4687 15.8113C27.726 15.8113 27.9727 15.9135 28.1546 16.0954L36.8734 24.8141C36.9636 24.9041 37.0351 25.011 37.084 25.1287C37.1328 25.2464 37.158 25.3726 37.158 25.5C37.158 25.6274 37.1328 25.7536 37.084 25.8713C37.0351 25.989 36.9636 26.0959 36.8734 26.1859L28.1546 34.9046C27.9727 35.0865 27.726 35.1887 27.4687 35.1887C27.2115 35.1887 26.9648 35.0865 26.7829 34.9046C26.6009 34.7227 26.4988 34.476 26.4988 34.2187C26.4988 33.9615 26.6009 33.7148 26.7829 33.5329L34.8177 25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNextArrow);
export default __webpack_public_path__ + "static/media/slider-next-arrow.007b6ebb9c931f5b9fa4fc24dcb36186.svg";
export { ForwardRef as ReactComponent };